import { useTranslation } from 'react-i18next'
import EmptyState from '../../components/ui/EmptyState'
import PageHeader from '../../components/ui/PageHeader'
// Yalnız `admin-page` kabuğu için; `timePortfolio.css` (.tp-* seçiciler) bu ekranda kullanılmıyor.
import '../admin/admin.css'

/**
 * **Zaman Portföyü Raporu** (28.09.2026) — Genel Müdür'ün zamanının nereye gittiğinin **okuma**
 * yüzeyi.
 *
 * <p><b>Başlık "Rapor"dur ve anayasanın "ekran başlığı = menü adı" kuralı burada YALNIZ KISMEN
 * tutar</b> — bilinçli bir sapmadır. Menü öğesi role göre değişir: Özel Kalem grubu açtığında
 * "Rapor" yazar (kural sağlanır), Genel Müdür'de ise grup düzleşip <b>"Zaman Portföyü"</b> yazar
 * (kullanıcı isteği 28.09.2026 — GM'de alt menü istenmedi). İki menü adına aynı anda eşit bir başlık
 * yoktur; bağlamı üst şerit taşır: {@code breadcrumbLabelKey} ile orada "Zaman Portföyü Raporu"
 * görünür. Aynı tercih {@code TimePortfolioPage} ("Veri Girişi") için de geçerlidir.
 *
 * <p><b>Bu sürüm bilinçli olarak İSKELETTİR</b> (kullanıcı kararı 28.09.2026): menü yerleşimi ve
 * yetkilendirme bu turda teslim edilir, raporun içeriği ayrı bir iştir. Sayfa **hiçbir uç
 * çağırmaz** — backend'de zaten özet/agregasyon ucu yoktur (`timeportfolio` paketinde yalnız iki
 * CRUD controller'ı var) ve `specs/112` raporu açıkça kapsam dışı bırakmıştır. Boş durum,
 * "yükleniyor" sanılmasın diye {@link EmptyState} ile ve içeriğin sonra geleceğini söyleyen bir
 * metinle çizilir.
 *
 * <p><b>Yetki:</b> `TIME_PORTFOLIO_REPORT_VIEW` (roller 1 Super Admin · 3 Özel Kalem Personeli ·
 * 4 Özel Kalem Müdürü · **5 Genel Müdür**). Veri girişinden ayrı bir koddur: `TIME_PORTFOLIO_MANAGE`
 * tam CRUD'dur ve onu Genel Müdür'e vermek giriş yüzeyini de açardı. Rota kilidi menüden türer
 * (`menuGuard`); ekranın kendisi ayrıca bir kapı taşımaz.
 *
 * <p><b>İçerik geldiğinde:</b> özet uçları eklenir, bu dosyadaki boş durum yerini rapora bırakır ve
 * `Grants`'a bir `HAS_TIME_PORTFOLIO_REPORT_VIEW` bileşiği eklenerek uçlar sunucuda da korunur.
 */
export default function TimePortfolioReportPage() {
  const { t } = useTranslation()

  return (
    <div className="admin-page">
      <PageHeader title={t('nav.timePortfolio.report')} />
      <EmptyState
        icon="pi pi-chart-bar"
        title={t('timePortfolio.report.empty.title')}
        description={t('timePortfolio.report.empty.desc')}
      />
    </div>
  )
}
